import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader";
import WaitForData from "../../common/data-fetching/WaitForData";
import ReportProblemOutlined from "@material-ui/icons/ReportProblemOutlined";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useQueryJobCount from "../view/useQueryJobCount";
import JobStatusEnum from "../../jobs/JobStatusEnum";

export default function PublishedJobByEmployerCountItem(props) {
  const { employerId } = props;
  const { data: count, loading, errors } = useQueryJobCount({employerId, status: JobStatusEnum.PUBLISHED});

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <Row>
            <Col>
              <span>{count}</span>
            </Col>
          </Row>
        )}
      />
    </HorizontalLoader>
  );
}
